import $ from 'jquery';
import { brandAlertTemplate, removeAlertStyle } from '@global/helpers/brandAlertTemplate';
import detectLang from '@global/helpers/detectLang';

window.detectLang = detectLang();

const allTemplates = brandAlertTemplate(window.PictureContainer);

const {
  alertInfoTemplate,
  alertConfirmTemplate,
  alertSpecialTemplate,
  squarebearAlertInfoTemplate,
  commonCartDeleteTemplate,
} = allTemplates;

const brand = window.PictureContainer;

const AlertDialog = (($, o) => {
  const $body = $('body');

  const alertInfo = (msg, tmpl, textAlign, callback, name) => {
    const $tmpl = $(tmpl);

    $tmpl.attr('data-name', name === undefined ? '' : name);

    $tmpl.find('.modal-info').html(msg);
    $tmpl.find('.modal-info').addClass(textAlign);

    $body.css({ overflow: 'hidden' });
    $body.append($tmpl);

    $('.btn-cancel-alert')
      .unbind()
      .click(function (e) {
        e.preventDefault();
        removeAlertStyle.call($(this), brand);
        $body.css({ overflow: '', 'padding-right': '' });
      });

    $('.alert-confirm-btn')
      .unbind()
      .click(function (e) {
        e.preventDefault();
        removeAlertStyle.call($(this), brand);
        $body.css({ overflow: '', 'padding-right': '' });

        if (callback) {
          callback();
        }
      });

    $('.btn-close-alert, .btn-confirm-alert')
      .unbind()
      .click(function (e) {
        e.preventDefault();
        $(this).addClass('disabled');
        removeAlertStyle.call($(this), brand);
        $body.css({ overflow: '', 'padding-right': '' });

        if (callback) {
          callback();
        }
      });
  };

  const alertCartInfo = (msg, tmpl, textAlign, callback, callback2, name) => {
    const $tmpl = $(tmpl);

    $tmpl.attr('data-name', name === undefined ? '' : name);

    $tmpl.find('.modal-info').html(msg);
    $tmpl.find('.modal-info').addClass(textAlign);

    $body.css({ overflow: 'hidden' });
    $body.append($tmpl);

    $('.btn-cancel-alert').on('click', function (e) {
      e.preventDefault();
      removeAlertStyle.call($(this), brand);
      $body.css({ overflow: '', 'padding-right': '' });
    });

    $('.btn-close-alert, .btn-confirm-alert').on('click', function (e) {
      e.preventDefault();
      $(this).addClass('disabled');
      $(this).parents('.alert-modal-style').remove();
      $body.css({ overflow: '', 'padding-right': '' });
      if (callback == undefined || callback == null) return;
      callback();
    });

    $('.btn-confirm-wish').on('click', function () {
      $(this).addClass('disabled');
      $(this).parents('.alert-modal-style').remove();
      $body.css({ overflow: '', 'padding-right': '' });
      if (callback == undefined || callback == null) return;
      callback2();
    });
  };

  o.alert = (msg, callback, name) => {
    alertInfo(msg, alertInfoTemplate, 'text-center', callback, name);
  };

  o.confirm = (msg, callback, name) => {
    alertInfo(msg, alertConfirmTemplate, 'text-center', callback, name);
  };

  o.special = (msg, callback, name) => {
    alertInfo(msg, alertSpecialTemplate, 'text-center', callback, name);
  };

  o.alertBear = (msg, callback, name) => {
    alertInfo(msg, squarebearAlertInfoTemplate, 'text-center', callback, name);
  };

  o.cartDelete = (msg, callback, callback2, name) => {
    alertCartInfo(msg, commonCartDeleteTemplate, 'text-center', callback, callback2, name);
  };

  return o;
})($, window.AlertDialog || {});

export default AlertDialog;
